module.exports = __webpack_public_path__ + "assets/img/mobile-header.jpg";